<template>
  <div class="search-results-v2">
    <!-- Results List -->
    <div v-if="responseData.length > 0 || replaceItemAnalogs != undefined || replaceItem != undefined"
      class="results-list-v2">
      <!-- Replace Item (if exists, without analogs) -->
      <div v-if="replaceItem != undefined && replaceItemAnalogs == undefined" class="result-item-v2">
        <div class="result-image-v2">
          <img :src="appconfig.Point + `/` + replaceItem.image" :alt="replaceItem.full_name" />
        </div>

        <div class="result-content-v2">
          <div class="result-header-v2">
            <div v-if="replaceItem.on_order" class="order-badge-v2">Під замовлення</div>
            <h4 class="result-title-v2">{{ replaceItem.full_name }}</h4>
            <div class="result-meta-v2">
              <span class="result-code-v2">Код: {{ replaceItem.code }}</span>
              <span class="result-status-v2" :class="replaceItem.quantity == 0 ? 'status-order' : 'status-stock'">
                <i :class="replaceItem.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                {{ replaceItem.quantity == 0 ? 'Термін постачання до: ' +
                  replaceItem.terms : 'В наявності' }}
              </span>
            </div>
          </div>
        </div>

        <div class="result-price-v2">
          <div v-if="replaceItem.price > 0" class="price-info-v2">
            <span class="price-value-v2">
              {{ what == 'materials' ? (+replaceItem.p).toFixed(2) : replaceItem.price }}
            </span>
            <span class="price-currency-v2">{{ replaceItem.cy_name }}</span>
            <span class="price-unit-v2">
              / {{ what == 'materials' ? replaceItem.base_unit_name : replaceItem.sale_unit_name }}
            </span>
          </div>
        </div>

        <div class="result-select-v2">
          <div class="select-actions-v2">
            <span class="replace-badge">
              <i class="fa fa-exchange-alt"></i>
              Заміна
            </span>
          </div>
        </div>
      </div>

      <!-- Separator between replace item and search results -->
      <div v-if="(replaceItem != undefined || replaceItemAnalogs != undefined) && responseData.length > 0"
        class="replace-separator">
        <div class="replace-separator-line"></div>
        <div class="replace-separator-text">
          <i class="fa fa-exchange-alt"></i>
          <span>Оберіть заміну з результатів пошуку нижче</span>
        </div>
        <div class="replace-separator-line"></div>
      </div>

      <!-- Replace Item (if exists, with analogs) -->
      <div v-if="replaceItemAnalogs != undefined" class="result-item-v2">
        <div class="result-image-v2">
          <img :src="appconfig.Point + `/` + replaceItemAnalogs.image" :alt="replaceItemAnalogs.full_name" />
        </div>

        <div class="result-content-v2">
          <div class="result-header-v2">
            <div v-if="replaceItemAnalogs.on_order" class="order-badge-v2">Під замовлення</div>
            <h4 class="result-title-v2">{{ replaceItemAnalogs.full_name }}</h4>
            <div class="result-meta-v2">
              <span class="result-code-v2">Код: {{ replaceItemAnalogs.code }}</span>
              <span class="result-status-v2"
                :class="replaceItemAnalogs.quantity == 0 ? 'status-order' : 'status-stock'">
                <i :class="replaceItemAnalogs.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                {{ replaceItemAnalogs.quantity == 0 ? 'Термін постачання до: ' +
                  replaceItemAnalogs.terms : 'В наявності' }}
              </span>
              <button v-if="replaceItemAnalogs.analogs !== undefined && replaceItemAnalogs.analogs.length > 0"
                class="btn-v2 btn-outline-v2 btn-sm-v2" @click.prevent="takeItemAnalogs(replaceItemAnalogs)">
                <i class="fa fa-copy"></i>
                Аналоги
              </button>
            </div>
          </div>
        </div>

        <div class="result-price-v2">
          <div v-if="replaceItemAnalogs.price > 0" class="price-info-v2">
            <span class="price-value-v2">
              {{ what == 'materials' ? (+replaceItemAnalogs.p).toFixed(2) : replaceItemAnalogs.price }}
            </span>
            <span class="price-currency-v2">{{ replaceItemAnalogs.cy_name }}</span>
            <span class="price-unit-v2">
              / {{ what == 'materials' ? replaceItemAnalogs.base_unit_name : replaceItemAnalogs.sale_unit_name }}
            </span>
          </div>
        </div>

        <div class="result-select-v2">
          <div class="select-actions-v2">
            <button class="btn-v2 btn-primary-v2" :id="'_' + replaceItemAnalogs.ref"
              @click="takeItem(replaceItemAnalogs)" :disabled="exists(replaceItemAnalogs.ref)">
              <i class="fa fa-check"></i>
              Обрати
            </button>
          </div>
        </div>
      </div>

      <!-- Regular Results -->
      <div v-for="(item, index) in responseData" :key="index" class="result-item-v2">
        <div class="result-image-v2">
          <img :src="appconfig.Point + `/` + item.image" :alt="item.full_name" loading="lazy" />
        </div>

        <div class="result-content-v2">
          <div class="result-header-v2">
            <div v-if="item.on_order" class="order-badge-v2">Під замовлення</div>
            <h4 class="result-title-v2">{{ item.full_name }}</h4>
            <div class="result-meta-v2">
              <span class="result-code-v2">Код: {{ item.code }}</span>
              <span class="result-status-v2" :class="item.quantity == 0 ? 'status-order' : 'status-stock'">
                <i :class="item.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                {{ item.quantity == 0 ? 'Термін постачання до: ' + item.terms : 'В наявності' }}
              </span>
              <button v-if="item.analogs !== undefined && item.analogs.length > 0"
                class="btn-v2 btn-outline-v2 btn-sm-v2" @click.prevent="takeItemAnalogs(item)">
                <i class="fa fa-copy"></i>
                Аналоги
              </button>
            </div>
          </div>
        </div>

        <div class="result-price-v2">
          <div v-if="item.price > 0" class="price-info-v2">
            <span class="price-value-v2">{{ (+item.p).toFixed(2) }}</span>
            <span class="price-currency-v2">{{ item.cy_name }}</span>
            <span class="price-unit-v2">
              / {{ what == 'materials' ? item.base_unit_name : item.sale_unit_name }}
            </span>
          </div>
        </div>

        <div class="result-select-v2">
          <div v-if="canSelect(item)" class="select-actions-v2">
            <button class="btn-v2 btn-primary-v2" :id="'_' + item.ref" @click.prevent="takeItem(item)"
              :disabled="exists(item.ref)">
              <i class="fa fa-check"></i>
              Обрати
            </button>
            <button v-if="item.recommends != undefined && item.recommends.length > 0 && what === 'materials'"
              class="btn-v2 btn-outline-v2 btn-sm-v2" :id="'_' + item.ref" @click.prevent="takeItemEdges(item)">
              <i class="fa fa-border-all"></i>
              Кромки
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else class="empty-state-v2">
      <div class="empty-icon-v2">
        <i class="fa fa-search"></i>
      </div>
      <h3 class="empty-title-v2">Даних немає</h3>
      <p class="empty-description-v2">Спробуйте змінити параметри пошуку</p>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: "search-render",
  props: ['what', 'responseData'],
  data() {
    return {
      appconfig: appconfig,
      details: this.$store.state.data.details,
    }
  },
  computed: {

    materials() {
      return this.$store.state.data.materials;
    },
    edges() {
      return this.$store.state.data.edges;
    },
    allowNoPrice() {
      return this.$store.state.auth.settings.allow_no_price || false;
    },
    replaceItemAnalogs() {
      let item = undefined;
      let replace = this.$store.state.data.replace;
      if (replace !== null) {
        if (this.responseData.filter(el => el.ref === replace).length === 0 || this.responseData.length == 0) {
          item = this[this.what].find(el => el.ref === replace);
        }
      }
      return item != undefined && item.analogs && item.analogs.length > 0 ? item : undefined;
    },
    replaceItem() {
      let item = undefined;
      let replace = this.$store.state.data.replace;
      if (replace !== null) {
        if (this.responseData.filter(el => el.ref === replace).length === 0 || this.responseData.length == 0) {
          item = this[this.what].find(el => el.ref === replace);
        }
      }
      return item;
    }
  },
  methods: {

    exists(ref) {
      return this[this.what].find(el => el.ref === ref) ? 'disabled' : false
    },
    canSelect(item) {
      // Если allow_no_price включен, показываем всегда
      if (this.allowNoPrice) {
        return true;
      }
      // Иначе показываем только если есть цена
      return item.price > 0;
    },
    takeItem(item) {
      let elem = this[this.what].find(el => el.ref === item.ref);
      if (elem) return;
      let replace = this.$store.state.data.replace;
      console.log('Replace: ' + replace);
      //Замена или добавление
      if (replace != null) {
        let toReplaceIndex = this[this.what].findIndex(el => el.ref === replace);
        console.log('To Replace Index: ' + toReplaceIndex);
        if (confirm('Замінити ' + this[this.what][toReplaceIndex].full_name + ' на ' + item.full_name)) {
          let current = this[this.what][toReplaceIndex]
          this.replaceInDetails(item); //change in details
          replace = null;
          item = { ...item, color_show: false, color: current.color }
          if (this.what === 'materials') {
            let defaultMaterial = this.$store.getters['data/defaultMaterial'];
            if (defaultMaterial.ref === current.ref) {
              this.$store.commit('data/SET_DEFAULT_MATERIALS', item);
            }
            this[this.what].splice(toReplaceIndex, 1, item);
            this.$store.commit('data/SET_MATERIALS', this[this.what]);
          }
          if (this.what === 'edges') {
            let defaultEdge = this.$store.getters['data/defaultEdge'];
            if (defaultEdge.ref === current.ref) {
              this.$store.commit('data/SET_DEFAULT_EDGES', item);
            }
            this[this.what].splice(toReplaceIndex, 1, item);
            this.$store.commit('data/SET_EDGES', this[this.what]);
          }
          document.getElementById('_' + item.ref).setAttribute("disabled", "disabled");
          this.$store.commit('data/SET_REPLACE', null);
          $('#searchModal').modal('hide');
        }


      } else {
        // this[this.what].push(item);
        document.getElementById('_' + item.ref).setAttribute("disabled", "disabled");
        if (this.what === 'materials') {
          this.$store.commit('data/ADD_MATERIALS', item);
        }
        if (this.what === 'edges') {
          this.$store.commit('data/ADD_EDGES', item);
        }
      }

    },
    replaceInDetails(item) {
      let replace = this.$store.state.data.replace;

      if (this.what === 'materials') {
        this.details
          .filter(el => el.material === replace)
          .forEach(i => {
            i.material = item.ref;
          });
      } else if (this.what === 'edges') {
        this.details
          .filter(el => el.edge_t === replace)
          .forEach(i => {
            i.edge_t = item.ref;
          });
        this.details
          .filter(el => el.edge_b === replace)
          .forEach(i => {
            i.edge_b = item.ref;
          });
        this.details
          .filter(el => el.edge_l === replace)
          .forEach(i => {
            i.edge_l = item.ref;
          });
        this.details
          .filter(el => el.edge_r === replace)
          .forEach(i => {
            i.edge_r = item.ref;
          });
        this.details
          .filter(el => el.edge_template === replace)
          .forEach(i => {
            i.edge_template = item.ref;
          });
      }
    },
    takeItemEdges(item) {
      this.$root.$emit('edges_change', { 'edges': item.recommends || [], 'material': item, what: this.what });
      $('#recommendModal').modal();
      $('#searchModal').modal('hide');
      this.$store.commit('data/SET_MODAL', 'searchModal');
    },
    takeItemAnalogs(item) {
      this.$root.$emit('analogs_change', { 'analogs': item.analogs || [], 'material': item, what: this.what });
      $('#searchModal').modal('hide');
      $('#analogsModal').modal();
      this.$store.commit('data/SET_MODAL', 'searchModal');

    }
  }
}

</script>